module.exports = __webpack_public_path__ + "img/MAC1630_R.dc74549e.png";